import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { store } from './app.reducer';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptor/auth/auth.interceptor';
import { loginEffect } from './state/effects/loginEffects';
import { forgotPasswordEffect } from './state/effects/forgotPasswordEffects';
import { createPasswordEffect } from './state/effects/createPasswordEffects';
import { companyEffect } from './state/effects/companyEffects';
import { addNewAccountEffect } from './state/effects/addNewccountEffect';
import { documentTabEffects } from './state/effects/documentsTabEffects';
import { DatePipe } from '@angular/common';
import { vehicleEffect } from './state/effects/vehicleEffects';
import { operatingAuthorityEffect } from './state/effects/operatingAuthorityEffects';
import { operatingAuthorityApplicationEffect } from './state/effects/operatingAuthorityApplicationEffects';
export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideRouter(routes),
    provideClientHydration(),
    provideStore(store),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideEffects([
      loginEffect,
      forgotPasswordEffect,
      createPasswordEffect,
      companyEffect,
      addNewAccountEffect,
      documentTabEffects,
      vehicleEffect,
      operatingAuthorityEffect,
      operatingAuthorityApplicationEffect,
    ]),
    provideStoreDevtools({ maxAge: 25 }),
    provideAnimationsAsync(),
  ],
};
